import React from 'react'
import _ from 'lodash/fp'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { useMutation } from 'react-apollo'
import gql from 'graphql-tag'
import localStore from 'localforage'

import * as ProfileReducer from '../../../reducers/profile'

import { builder, BuilderComponent } from '@builder.io/react'
import LoginDialog from '../components/LoginDialog'
import { REFERRER_KEY } from '../index'

builder.init('32eea804311a4d17817f2e534ded7af8')

const builders = {
  notDanish: 'a2661509e6d142fe9428f86933edd4a4'
}

const initSignupMutation = gql`
mutation($referrer: ID) {
  signUpForMembership(input: {
    itemId: "GLFR_OPEN"
    referrer: $referrer
  })
}
`

const SimpleRegister = props => {
  const [initSignup] = useMutation(initSignupMutation)
  const isDanish = !props.isSignedIn || // We only want to show the 'vær dansk' page to authed users
                   _.get('country_code', props.profile) === 'dk'

  React.useEffect(() => {
    const doStuff = async () => {
      if (_.get('profile.apolloUser.isInGLFROpen', props)) {
        props.history.replace(`/u/${props.profile.handle}/open`)
        return
      }
      if (isDanish) {
        const referrer = await localStore.getItem(REFERRER_KEY)
        initSignup({ variables: { referrer } }).then(() => {
          props.history.push('/open/accept')
        }).catch(console.log)
      }
    }
    doStuff()
  }, [props.profile.apolloUser, isDanish])

  if (!isDanish) {
    return (
      <div style={{ paddingBottom: 64, maxWidth: 1280 }}>
        <BuilderComponent
          model='page'
          entry={builders.notDanish}
        />
      </div>
    )
  }

  if (!props.isSignedIn) {
    return (
      <div style={{ paddingBottom: 64 }}>
        <LoginDialog open />
      </div>
    )
  }

  return false
}

export default _.compose(
  withRouter,
  connect(
    s => {
      const profile = ProfileReducer.selectors.getProfile(s)
      return {
        profile
      }
    }
  )
)(SimpleRegister)
